import { render, staticRenderFns } from "./FacialOrderDetail.vue?vue&type=template&id=fefcd99c&scoped=true"
import script from "./FacialOrderDetail.vue?vue&type=script&lang=js"
export * from "./FacialOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./FacialOrderDetail.vue?vue&type=style&index=0&id=fefcd99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefcd99c",
  null
  
)

export default component.exports